const addresses = {
  data: () => ({
    editingLoading: false,
    wtCustomer: {},
    customerOldVal: {
      address: {}
    }
  }),
  watch: {
    newNsearchCustomer: {
      deep: true,
      handler (newValue) {
        const vmCst = this
        let oldValue = Object.assign({}, this.customerOldVal)
        if (this.autoSearch) {
          clearTimeout(this.wtCustomer.timeout)
          this.wtCustomer.timeout = setTimeout(function () {
            let newPhone = (newValue.phone !== oldValue.phone) || false,
                newName = (newValue.name !== oldValue.name) || false,
                newCpf = (newValue.identity !== oldValue.identity) || false,
                newBirth = (newValue.birth_date !== oldValue.birth_date) || false,
                newCep = (newValue.address && newValue.address.cep !== oldValue.address.cep) || false,
                newFullAddress = (newValue.address && (newValue.address.address !== oldValue.address.address || newValue.address.num !== oldValue.address.num || newValue.address.state !== oldValue.address.state || newValue.address.city !== oldValue.address.city)) || false,
                newPartialAddress = (newValue.address && (newValue.address.address !== oldValue.address.address || newValue.address.num !== oldValue.address.num)) || false
            if (newPhone || newName || newCpf || newBirth || newCep || newFullAddress || newPartialAddress) vmCst.searchCustomers(newValue)
          }, 500)
        }
        if (newValue.oldValue) delete newValue.oldValue
        this.customerOldVal = Object.assign({}, newValue)
      }
    }
  },
  methods: {
    searchCustomers ({ phone, name, identity, birth_date, address } = { phone: false, name: false, identity: false, birth_date: false, address: false }) {
      this.searchLoading = true
      const vm = this
      setTimeout(function () { vm.searchLoading = false }, 3000)
      this.customersList = {}
      phone = (phone ? phone.trim().replace(/[^0-9]/g, '') : false)
      phone = (phone.length === 11 ? phone : false)
      identity = (identity ? identity.trim().replace(/[^0-9]/g, '') : false)
      identity = (identity.length === 11 ? identity : false)
      name = (name ? name.toLowerCase().trim() : false)
      var cep = (address.cep && address.cep.length === 9 ? address.cep : false),
          num = address.num || false,
          city = address.city || false,
          state = address.state || false
      address = address.address || false
      const addressCheck = (cep || (address && num && city && state))
      if (phone || cep || name || identity || birth_date || address || addressCheck) {
        var customersList = this.get_data.customers
        customersList = (customersList ? this.filterNsortCustomers(customersList, { phone, name, identity, birth_date, cep, address, num, city, state }) : {})
        this.customersList = Object.assign({}, customersList)
        if (customersList.length && customersList[0].order > 5 && customersList[0].id !== this.newNsearchCustomer.suggestion) {
          this.newNsearchCustomer.suggestion = customersList[0].id
          this.selectCustomer(customersList[0])
        }
      }
      this.searchLoading = false
    },
    filterNsortCustomers (customersList = {}, { phone, name, identity, birth_date, cep, address, num, city, state } = { phone: false, name: false, identity: false, birth_date: false, cep: false, address: false, num: false, city: false, state: false }) {
      const addressCheck = (cep && address && num && city && state)
      function customersFilter (el) {
        var match = Object.assign({}, {})
        match.idMatch = (name && el.id === parseInt(name)) || false
        match.phoneMatch = (phone && phone.length && String(el.phone) === String(phone)) || false
        match.identityMatch = (identity && identity.length && String(el.identity) === String(identity)) || false
        match.birthMatch = (birth_date && birth_date.length && String(el.birth_date) === String(birth_date)) || false
        match.nameMatch = (name && name.length && el.name.length && el.name.toLowerCase().trim().search(name) > -1) || false
        match.cepMatch = (cep && cep.length === 9 && el.addresses.length && (!!el.addresses.find((el2) => (el2.cep === cep)))) || false
        match.fullAddressMatch = (addressCheck && (el.addresses.length && (!!el.addresses.find((el2) => (el2.address === address && el2.num === num && el2.state === state && el2.city === city))))) || false
        match.partialAddressMatch = (!match.fullAddressMatch && address.length > 5 && (el.addresses.length && (!!el.addresses.find((el2) => el2.address.toLowerCase().trim().search(address.toLowerCase().trim()) > -1)))) || false
        match.partialAddressNumMatch = (match.partialAddressMatch && (!!el.addresses.find((el2) => el2.address.toLowerCase().trim().search(address.toLowerCase().trim()) > -1 && el2.num.toString() === num.toString()))) || false
        const matched = Boolean(Object.values(match).find((el2) => el2 !== false)) || false
        // IF SOME MATCH SET ELEMENT ORDER POINTS
        if (matched) {
          var order_ = 0
          order_ = (match.idMatch ? order_ + 4 : order_) // ID MATCH
          order_ = (el.phone.length === 11 ? order_ + 1 : order_) // HAVE PHONE
          order_ = (match.phoneMatch ? order_ + 4 : order_) // PHONE MATCH
          order_ = (match.identityMatch ? order_ + 6 : order_) // PHONE MATCH
          order_ = (match.birthMatch ? order_ + 3 : order_) // BIRTH MATCH
          order_ = (match.nameMatch ? order_ + 1 : order_) // NAME MATCH
          order_ = (match.cepMatch ? order_ + 1 : order_) // CEP MATCH
          order_ = (el.addresses.length ? order_ + 1 : order_) // HAVE ADDRESS
          order_ = (match.partialAddressMatch ? order_ + 1 : order_) // PARTIAL ADDRESS MATCH
          order_ = (match.partialAddressNumMatch ? order_ + 1 : order_) // PARTIAL ADDRESS + NUM MATCH
          order_ = (match.fullAddressMatch ? order_ + 2 : order_) // FULL ADDRESS MATCH
          el.order = order_
          el.match = Object.assign({}, match)
        }
        return matched
      }
      customersList = (customersList.length ? customersList.filter(customersFilter) : {})
      if (customersList.length) customersList.sort(function (a, b) { return b.order - a.order })
      return customersList
    }
  }
}

export default addresses
